import axios from '../../utils/axios';

export default function deleteLGCollection(adminId, billId, data) {
    return (
        axios.post(`/admin/${adminId}/lGCollection/${billId}/delete
        `,  data )
    )
}
